const initialState = {
  status: "invalid",
  data: null
};

export default (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case "COURSE_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "COURSE_SUCCESS":
      return {
        ...state,
        status: "success",
        data: payload.data,
      };
    case "COURSE_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
